import { defineStore } from "pinia";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import { getLicenseStatus } from "~/modules/license/utils/getLicenseStatus";

export const useDtwinModelsStore = defineStore("DtwinModelsStore", () => {
  const dtwinModels: Ref<DtwinModel[] | undefined> = ref();

  function setDtwinModels(models: DtwinModel[]) {
    dtwinModels.value = models;
  }

  return {
    setDtwinModels,
    dtwinModels,
  };
});
